import { AriaRole, ReactNode } from "react";
import cx from "classnames";

import { TypographyProps } from "ds/components/Typography";

import Box, { BoxProps } from "../../Box";
import styles from "./styles.module.css";
import CardTitle from "./Title";

export type CardHeaderProps = {
  prefix?: ReactNode;
  suffix?: ReactNode;
  titleSuffix?: ReactNode;
  titleHtmlFor?: string;
  titleTag?: TypographyProps["tag"];
  titleVariant?: TypographyProps["variant"];
  children: ReactNode;
  className?: string;
  align?: BoxProps["align"];
  role?: AriaRole;
};

const CardHeader = ({
  prefix,
  suffix,
  titleSuffix,
  children,
  titleHtmlFor,
  titleTag = "span",
  titleVariant,
  className,
  align = "center",
  role,
}: CardHeaderProps) => {
  return (
    <Box justify="between" align="center" className={cx(styles.header, className)} role={role}>
      <Box grow="1" align={align} className={styles.titleWrapper}>
        {prefix}
        {typeof children === "string" ? (
          <CardTitle variant={titleVariant} tag={titleTag} htmlFor={titleHtmlFor}>
            {children}
          </CardTitle>
        ) : (
          children
        )}
        {titleSuffix}
      </Box>
      {suffix}
    </Box>
  );
};

CardHeader.displayName = "DS.Card.Header";

export default CardHeader;
